module.exports = __webpack_public_path__ + "img/en-nz.38ffc3ba.svg";